document.addEventListener('DOMContentLoaded', () => {
  const filterForm = document.getElementById('CollectionFiltersForm');
  const layout = document.querySelector('.collection-layout-wrapper');

  const hasFilters =
    filterForm &&
    filterForm.querySelector(
      '.filter-checkbox-list, .dynamic-price-range-canva-block, .dynamic-cat-nav, #SortBySelect'
    );

  if (!hasFilters) {
    if (layout) layout.classList.add('no-filters');
    document
      .querySelectorAll('.mobile-filter-toggle-btn, .filter-drawer-overlay, .collection-filters-sidebar')
      .forEach((el) => el.remove());
  }

  if (!filterForm) return;

  const productGrid = document.getElementById('HousiousProductGrid');
  const gridContainer = document.getElementById('ProductGridContainer');

  
function sortTaggedProductsFirst(grid) {
  if (!grid) return;

  const products = Array.from(grid.children);

  products.sort((a, b) => {
    const aTagged = a.querySelector('.custom-product-card--tagged') !== null;
    const bTagged = b.querySelector('.custom-product-card--tagged') !== null;

    return Number(bTagged) - Number(aTagged);
  });

  products.forEach((product) => grid.appendChild(product));
}


  const loadedCountEl = document.getElementById('LoadedProductsCount');
  const totalCountEl = document.getElementById('ShowingProductsTotal');

  const defaultCollectionHandle = filterForm.dataset.currentCollectionHandle || '';
  let defaultCollectionUrl = filterForm.dataset.currentCollectionUrl || window.location.pathname;
  if (window.location.pathname.includes('all-collections')) {
    defaultCollectionUrl = '/collections/all';
  }

  const SECTION_ID = 'main-collection-product-grid';
  const SEE_MORE_LIMIT = 5;

  let filterAbortController = null;
  let isLoadingMore = false;
  let scrollObserver = null;
  let activeNextUrls = {};
  let boundsComputedForKey = null;
  let isUserInteracted = false; // Tracks whether the user has actively filtered or interacted

  function injectSeeMoreStyles() {
    if (document.getElementById('sf-see-more-styles')) return;
    const style = document.createElement('style');
    style.id = 'sf-see-more-styles';
    style.textContent =
      '.filter-checkbox-list li.sf-extra-hidden{display:none !important;}' +
      '.sf-see-more-btn{display:inline-block;margin:10px 0 0;padding:0;border:0;' +
      'background:transparent;color:#721033;font-size:12.5px;font-weight:700;' +
      'cursor:pointer;text-decoration:underline;}';
    document.head.appendChild(style);
  }

  function initSeeMore() {
    injectSeeMoreStyles();
    filterForm.querySelectorAll('.filter-checkbox-list').forEach((list) => {
      if (list.closest('.custom-navigation-categories')) return;
      if (list.dataset.sfSeeMore === 'true') return;

      const items = Array.from(list.children).filter((el) => el.tagName === 'LI');
      if (items.length <= SEE_MORE_LIMIT) return;

      list.dataset.sfSeeMore = 'true';
      const extra = items.slice(SEE_MORE_LIMIT);
      let open = extra.some((li) => li.querySelector('input:checked'));

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sf-see-more-btn';

      const render = () => {
        extra.forEach((li) => li.classList.toggle('sf-extra-hidden', !open));
        btn.textContent = open ? 'See less' : 'See more (' + extra.length + ')';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      btn.addEventListener('click', () => {
        open = !open;
        render();
      });

      render();
      list.insertAdjacentElement('afterend', btn);
    });
  }

  function countProductCards() {
    if (!productGrid) return 0;
    return productGrid.querySelectorAll('.custom-product-card').length;
  }

  function getSelectedCollections() {
    const checked = Array.from(filterForm.querySelectorAll('.dynamic-cat-nav:checked'));
    if (checked.length === 0 || !isUserInteracted) {
      return [{ handle: defaultCollectionHandle, url: defaultCollectionUrl }];
    }
    return checked.map((cb) => ({
      handle: cb.dataset.collectionHandle,
      url: cb.dataset.collectionUrl
    }));
  }

  function buildBaseParams() {
    const deduped = new URLSearchParams();
    
    if (!isUserInteracted) {
      return deduped;
    }

    const raw = new FormData(filterForm);
    const rangeMin = filterForm.querySelector('.range-min');
    const rangeMax = filterForm.querySelector('.range-max');
    const hasCustomPrice = rangeMin && rangeMax && (
      parseFloat(rangeMin.value) > parseFloat(rangeMin.min) || 
      parseFloat(rangeMax.value) < parseFloat(rangeMax.max)
    );

    const seen = new Set();
    for (const [key, value] of raw.entries()) {
      if (seen.has(key)) continue;
      if (!hasCustomPrice && key.startsWith('filter.v.price')) continue;
      if (!value) continue;

      seen.add(key);
      deduped.set(key, value);
    }
    return deduped;
  }

  function withSection(url) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}section_id=${SECTION_ID}`;
  }

  function uniqueKeyForCard(card) {
    const link = card.querySelector && card.querySelector('a[href*="/products/"]');
    const titleEl = card.querySelector('.product-card__title, .card__heading, h3, h4');
    return link ? link.getAttribute('href').split('?')[0] : (titleEl ? titleEl.textContent.trim() : card.innerHTML.slice(0, 80));
  }

  function mergeCardsInto(existingKeys, sourceGrid, targetFragment) {
    if (!sourceGrid) return;
    Array.from(sourceGrid.children).forEach((card) => {
      const key = uniqueKeyForCard(card);
      if (!existingKeys.has(key)) {
        existingKeys.add(key);
        const clone = card.cloneNode(true);
        clone.dataset.sfDynamic = 'true';
        targetFragment.appendChild(clone);
      }
    });
  }

  function parseTotalFromDoc(doc) {
    const el = doc.getElementById('ShowingProductsTotal');
    if (!el) return 0;
    const match = el.textContent.match(/[\d,]+/);
    return match ? parseInt(match[0].replace(/,/g, ''), 10) : 0;
  }

  function readPriceBoundsFromDoc(doc) {
    const block = doc.querySelector('.dynamic-price-range-canva-block');
    if (!block) return null;
    const min = parseFloat(block.dataset.priceMin);
    const max = parseFloat(block.dataset.priceMax);
    if (isNaN(min) || isNaN(max)) return null;
    return { min, max };
  }

  function reinitializeProductCards() {
    if (!productGrid) return;
    document.dispatchEvent(
      new CustomEvent('productCards:updated', { detail: { container: productGrid } })
    );
  }

  function updateCategoriesFromDoc(doc) {
    const newCatBlock = doc.querySelector('.custom-navigation-categories');
    const currentCatBlock = filterForm.querySelector('.custom-navigation-categories');
    if (newCatBlock && currentCatBlock) {
      const checkedHandles = Array.from(
        filterForm.querySelectorAll('.dynamic-cat-nav:checked')
      ).map((cb) => cb.dataset.collectionHandle);

      currentCatBlock.innerHTML = newCatBlock.innerHTML;

      currentCatBlock.querySelectorAll('.dynamic-cat-nav').forEach((cb) => {
        if (checkedHandles.includes(cb.dataset.collectionHandle)) {
          cb.checked = true;
        }
      });
    }
  }

  function sfUpdateCartUI(cart) {
    document
      .querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, #cart-icon-bubble span')
      .forEach((el) => (el.textContent = cart.item_count));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
  }

  function sfAddToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then((r) => {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(() => fetch('/cart.js'))
      .then((r) => r.json())
      .then((cart) => {
        sfUpdateCartUI(cart);
        return cart;
      });
  }

  function sfMarkAdded(btn) {
    const original = btn.innerHTML;
    btn.classList.add('is-added');
    btn.innerHTML = '<span class="custom-product-card__added-icon">✓</span> Added';
    setTimeout(() => {
      btn.classList.remove('is-added');
      btn.innerHTML = original;
      btn.disabled = false;
    }, 1800);
  }

  function sfSlide(media, dir, index) {
    if (!media) return;
    const slides = Array.from(media.querySelectorAll('[data-product-slide]'));
    const dots = Array.from(media.querySelectorAll('[data-slider-dot]'));
    if (slides.length < 2) return;
    const current = slides.findIndex((s) => s.classList.contains('is-active'));
    const next = index != null ? index : (current + dir + slides.length) % slides.length;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === next));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === next));
  }

  function sfToggleModal(card, open) {
    const modal = card.querySelector('[data-variant-modal]');
    if (!modal) return;
    modal.classList.toggle('is-active', open);
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  document.body.addEventListener('click', (e) => {
    const card = e.target.closest('.custom-product-card[data-sf-dynamic]');
    if (card) {
      const media = card.querySelector('[data-product-slider]');
      if (e.target.closest('[data-slider-prev]')) {
        e.preventDefault();
        sfSlide(media, -1);
        return;
      }
      if (e.target.closest('[data-slider-next]')) {
        e.preventDefault();
        sfSlide(media, 1);
        return;
      }
      const dot = e.target.closest('[data-slider-dot]');
      if (dot) {
        e.preventDefault();
        sfSlide(media, 0, parseInt(dot.dataset.sliderDot, 10));
        return;
      }
      if (e.target.closest('[data-quick-add-modal]')) {
        e.preventDefault();
        sfToggleModal(card, true);
        return;
      }
      if (e.target.closest('[data-modal-close]')) {
        e.preventDefault();
        sfToggleModal(card, false);
        return;
      }
      const single = e.target.closest('[data-quick-add-single]');
      if (single) {
        e.preventDefault();
        if (single.disabled) return;
        single.disabled = true;
        sfAddToCart(single.dataset.variantId)
          .then(() => sfMarkAdded(single))
          .catch(() => { single.disabled = false; });
        return;
      }
      const modalAdd = e.target.closest('[data-modal-add]');
      if (modalAdd) {
        e.preventDefault();
        const select = card.querySelector('[data-variant-select]');
        if (!select || !select.value || modalAdd.disabled) return;
        modalAdd.disabled = true;
        sfAddToCart(select.value)
          .then(() => {
            sfToggleModal(card, false);
            const qa = card.querySelector('.custom-product-card__quick-add');
            if (qa) sfMarkAdded(qa);
          })
          .catch(() => {})
          .finally(() => { modalAdd.disabled = false; });
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document
      .querySelectorAll('.custom-product-card[data-sf-dynamic] [data-variant-modal].is-active')
      .forEach((m) => {
        m.classList.remove('is-active');
        m.setAttribute('aria-hidden', 'true');
      });
  });

  
  function initPriceSliderFramework() {
    const rangeMinInput = filterForm.querySelector('.range-min');
    const rangeMaxInput = filterForm.querySelector('.range-max');
    const numMinInput = filterForm.querySelector('.dynamic-min-input');
    const numMaxInput = filterForm.querySelector('.dynamic-max-input');
    const sliderTrack = filterForm.querySelector('.slider-track');

    if (!rangeMinInput || !rangeMaxInput || !sliderTrack) return;

    function getLimits() {
      return {
        min: Number(rangeMinInput.min) || 0,
        max: Number(rangeMinInput.max) || 500
      };
    }

    function updateSliderTrack() {
      const { min, max } = getLimits();

      const minVal = Number(rangeMinInput.value);
      const maxVal = Number(rangeMaxInput.value);
      const range = max - min;

      // Keep the visual track stable if values temporarily cross.
      const visualMin = Math.min(minVal, maxVal);
      const visualMax = Math.max(minVal, maxVal);

      const percentMin = range
        ? ((visualMin - min) / range) * 100
        : 0;

      const percentMax = range
        ? ((visualMax - min) / range) * 100
        : 100;

      sliderTrack.style.left = percentMin + '%';
      sliderTrack.style.right = (100 - percentMax) + '%';
    }

    function applyPriceFilter() {
      const { min: minLimit, max: maxLimit } = getLimits();

      let minVal = numMinInput && numMinInput.value.trim() !== ''
        ? Number(numMinInput.value)
        : minLimit;

      let maxVal = numMaxInput && numMaxInput.value.trim() !== ''
        ? Number(numMaxInput.value)
        : maxLimit;

      if (!Number.isFinite(minVal) || !Number.isFinite(maxVal)) return;

      minVal = Math.max(minLimit, Math.min(minVal, maxLimit));
      maxVal = Math.max(minLimit, Math.min(maxVal, maxLimit));

      // Do not overwrite either input if the range is temporarily invalid.
      // The customer can edit the other input to correct it.
      if (minVal > maxVal) return;

      rangeMinInput.value = minVal;
      rangeMaxInput.value = maxVal;

      if (numMinInput) numMinInput.value = minVal;
      if (numMaxInput) numMaxInput.value = maxVal;

      updateSliderTrack();

      isUserInteracted = true;
      renderFilteredPage();
    }

    // Initialize the slider track without overwriting typed values.
    updateSliderTrack();

    // Range sliders: prevent the handles from crossing each other.
    rangeMinInput.oninput = () => {
      if (+rangeMinInput.value > +rangeMaxInput.value) {
        rangeMinInput.value = rangeMaxInput.value;
      }

      if (numMinInput) {
        numMinInput.value = rangeMinInput.value;
      }

      updateSliderTrack();
    };

    rangeMaxInput.oninput = () => {
      if (+rangeMaxInput.value < +rangeMinInput.value) {
        rangeMaxInput.value = rangeMinInput.value;
      }

      if (numMaxInput) {
        numMaxInput.value = rangeMaxInput.value;
      }

      updateSliderTrack();
    };

    rangeMinInput.onchange = applyPriceFilter;
    rangeMaxInput.onchange = applyPriceFilter;

    // Numeric inputs: allow empty fields and independent editing.
    [numMinInput, numMaxInput].forEach((input) => {
      if (!input) return;

      input.oninput = () => {
        // Do not interfere with Backspace or temporary empty values.
        if (input.value.trim() === '') return;

        const value = Number(input.value);
        if (!Number.isFinite(value)) return;

        const { min, max } = getLimits();
        const clampedValue = Math.max(min, Math.min(value, max));

        // Update only the corresponding slider.
        // Never overwrite the other numeric input while typing.
        if (input === numMinInput) {
          rangeMinInput.value = clampedValue;
        } else {
          rangeMaxInput.value = clampedValue;
        }

        updateSliderTrack();
      };

      input.onchange = applyPriceFilter;

      input.onkeydown = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyPriceFilter();
          input.blur();
        }
      };
    });
  }


  function applyPriceBounds(bounds) {
    if (!bounds) return;
    const rangeMinInput = filterForm.querySelector('.range-min');
    const rangeMaxInput = filterForm.querySelector('.range-max');
    const numMinInput = filterForm.querySelector('.dynamic-min-input');
    const numMaxInput = filterForm.querySelector('.dynamic-max-input');
    const block = filterForm.querySelector('.dynamic-price-range-canva-block');

    [rangeMinInput, rangeMaxInput, numMinInput, numMaxInput].forEach((input) => {
      if (!input) return;
      input.min = bounds.min;
      input.max = bounds.max;
    });

    if (block) {
      block.dataset.priceMin = bounds.min;
      block.dataset.priceMax = bounds.max;
    }

    if (rangeMinInput && parseFloat(rangeMinInput.value) < bounds.min) rangeMinInput.value = bounds.min;
    if (rangeMaxInput && parseFloat(rangeMaxInput.value) > bounds.max) rangeMaxInput.value = bounds.max;

    initPriceSliderFramework();
  }

  function renderFilteredPage() {
    if (filterAbortController) filterAbortController.abort();
    filterAbortController = new AbortController();
    const signal = filterAbortController.signal;

    const collections = getSelectedCollections();
    const collectionsKey = collections.map((c) => c.handle).sort().join(',');
    const boundsNeedRecompute = collectionsKey !== boundsComputedForKey;
    const baseParams = buildBaseParams();

    let addressUrl;
    if (collections.length === 1) {
      addressUrl = collections[0].url + (baseParams.toString() ? '?' + baseParams.toString() : '');
    } else {
      const combinedParams = new URLSearchParams(baseParams);
      combinedParams.set('collections', collections.map((c) => c.handle).join(','));
      addressUrl = defaultCollectionUrl + '?' + combinedParams.toString();
    }
    history.replaceState({ path: addressUrl }, '', addressUrl);

    activeNextUrls = {};

    const fetches = collections.map((col) => {
      const url = col.url + (baseParams.toString() ? '?' + baseParams.toString() : '');
      return fetch(withSection(url), { signal })
        .then((r) => r.text())
        .then((html) => ({ col, doc: new DOMParser().parseFromString(html, 'text/html') }));
    });

    Promise.all(fetches)
      .then((results) => {
        const existingKeys = new Set();
        const fragment = document.createDocumentFragment();
        let totalCount = 0;
        let bestMin = Infinity;
        let bestMax = -Infinity;

        results.forEach(({ col, doc }, index) => {
          const sourceGrid = doc.getElementById('HousiousProductGrid');
          mergeCardsInto(existingKeys, sourceGrid, fragment);

          totalCount += parseTotalFromDoc(doc);

          if (index === 0) {
            updateCategoriesFromDoc(doc);
          }

          if (boundsNeedRecompute) {
            const bounds = readPriceBoundsFromDoc(doc);
            if (bounds) {
              bestMin = Math.min(bestMin, bounds.min);
              bestMax = Math.max(bestMax, bounds.max);
            }
          }

          const nextLoader = doc.getElementById('InfiniteScrollLoader');
          if (nextLoader && nextLoader.dataset.nextUrl) {
            const nextParsedUrl = new URL(nextLoader.dataset.nextUrl, window.location.origin);
            if (isUserInteracted) {
              baseParams.forEach((val, key) => {
                nextParsedUrl.searchParams.set(key, val);
              });
            }
            activeNextUrls[col.url] = nextParsedUrl.pathname + nextParsedUrl.search;
          }
        });

        if (productGrid) {
          productGrid.innerHTML = '';
          productGrid.appendChild(fragment);
          sortTaggedProductsFirst(productGrid);
          reinitializeProductCards();
        }

        const loadedCount = countProductCards();
        if (loadedCountEl) loadedCountEl.textContent = loadedCount;

        const hasMorePages = Object.keys(activeNextUrls).length > 0;
        const displayTotal = hasMorePages ? Math.max(totalCount, loadedCount) : loadedCount;
        if (totalCountEl) totalCountEl.textContent = 'of ' + displayTotal;

        if (boundsNeedRecompute && isUserInteracted) {
          if (bestMin !== Infinity && bestMax !== -Infinity) {
            applyPriceBounds({ min: bestMin, max: bestMax });
          }
          boundsComputedForKey = collectionsKey;
        } else {
          initPriceSliderFramework();
        }

        syncInfiniteScrollLoader();
      })
      .catch((err) => {
        if (err.name !== 'AbortError') console.log(err);
      });
  }

  function observeLoader(loaderEl) {
    if (scrollObserver) scrollObserver.disconnect();
    scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) loadMoreProducts();
        });
      },
      { rootMargin: '400px' }
    );
    scrollObserver.observe(loaderEl);
  }

  function syncInfiniteScrollLoader() {
    let loader = document.getElementById('InfiniteScrollLoader');
    if (loader) loader.remove();

    const hasMore = Object.keys(activeNextUrls).length > 0;

    if (!hasMore) {
      if (scrollObserver) scrollObserver.disconnect();
      return;
    }

    if (gridContainer) {
      loader = document.createElement('div');
      loader.id = 'InfiniteScrollLoader';
      // Loader updated to show only the circular spinner without text
      loader.innerHTML = '<div class="loader-content"><div class="circular-spinner"></div></div>';
      gridContainer.appendChild(loader);
      observeLoader(loader);
    }
  }

  async function loadMoreProducts() {
    if (isLoadingMore || Object.keys(activeNextUrls).length === 0) return;
    isLoadingMore = true;

    const entries = Object.entries(activeNextUrls);
    const existingKeys = new Set(Array.from(productGrid.children).map(uniqueKeyForCard));
    const fragment = document.createDocumentFragment();
    const baseParams = buildBaseParams();

    try {
      await Promise.all(
        entries.map(async ([collectionUrl, nextUrl]) => {
          const response = await fetch(withSection(nextUrl));
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const sourceGrid = doc.getElementById('HousiousProductGrid');
          if (!sourceGrid || sourceGrid.children.length === 0) {
            delete activeNextUrls[collectionUrl];
            return;
          }

          mergeCardsInto(existingKeys, sourceGrid, fragment);

          const nextLoader = doc.getElementById('InfiniteScrollLoader');
          if (nextLoader && nextLoader.dataset.nextUrl) {
            const nextParsedUrl = new URL(nextLoader.dataset.nextUrl, window.location.origin);
            if (isUserInteracted) {
              baseParams.forEach((val, key) => {
                nextParsedUrl.searchParams.set(key, val);
              });
            }
            activeNextUrls[collectionUrl] = nextParsedUrl.pathname + nextParsedUrl.search;
          } else {
            delete activeNextUrls[collectionUrl];
          }
        })
      );

      if (productGrid && fragment.children.length > 0) {
        productGrid.appendChild(fragment);
        sortTaggedProductsFirst(productGrid);
        reinitializeProductCards();
      }

      const loadedCount = countProductCards();
      if (loadedCountEl) loadedCountEl.textContent = loadedCount;

      if (Object.keys(activeNextUrls).length === 0 && totalCountEl) {
        totalCountEl.textContent = 'of ' + loadedCount;
      }

      syncInfiniteScrollLoader();
    } catch (error) {
      console.error('Error auto-fetching products:', error);
    } finally {
      isLoadingMore = false;
    }
  }

  const initialLoader = document.getElementById('InfiniteScrollLoader');
  if (initialLoader && initialLoader.dataset.nextUrl) {
    const initialParsedUrl = new URL(initialLoader.dataset.nextUrl, window.location.origin);
    activeNextUrls[defaultCollectionUrl] = initialParsedUrl.pathname + initialParsedUrl.search;
    observeLoader(initialLoader);
  }

  document.body.addEventListener('click', (e) => {
    if (e.target.closest('.mobile-filter-toggle-btn')) {
      document.querySelector('.collection-filters-sidebar')?.classList.add('drawer-open');
      document.querySelector('.filter-drawer-overlay')?.classList.add('active');
    }
    if (e.target.classList.contains('filter-drawer-overlay')) {
      document.querySelector('.collection-filters-sidebar')?.classList.remove('drawer-open');
      document.querySelector('.filter-drawer-overlay')?.classList.remove('active');
    }
    if (e.target.closest('#MobileFilterCloseBtn')) {
      document.querySelector('.collection-filters-sidebar')?.classList.remove('drawer-open');
      document.querySelector('.filter-drawer-overlay')?.classList.remove('active');
    }
    if (e.target.id === 'ClearAllFilters') {
      e.preventDefault();
      isUserInteracted = false;
      filterForm.reset();
      filterForm.querySelectorAll('.dynamic-cat-nav').forEach((cb) => {
        cb.checked = cb.dataset.collectionHandle === defaultCollectionHandle;
      });
      renderFilteredPage();
    }
  });

  filterForm.addEventListener('change', (e) => {
    if (
      e.target.matches('.filter-checkbox-input') ||
      e.target.matches('.dynamic-cat-nav') ||
      e.target.matches('input[name="filter.v.availability"]') ||
      e.target.matches('input[type="checkbox"]') ||
      e.target.id === 'SortBySelect'
    ) {
      isUserInteracted = true;
      renderFilteredPage();
    }
  });

  sortTaggedProductsFirst(productGrid);

  initPriceSliderFramework();
  initSeeMore();
});